/**
 * Date helpers for the German "dd.mm.yyyy" or "dd.mm.yyyy - dd.mm.yyyy" strings
 * stored as plain text in the activities/workduties collections.
 *
 *  parseGermanDate("12.07.2026")              -> Date
 *  parseGermanDate("11.07.2026 - 12.07.2026") -> { start: Date, end: Date }
 *  isUpcoming(item)  -> true if today <= end-date of the item
 *  byUpcomingDate(a,b) -> chronological comparator
 *  filterUpcomingSorted(items) -> array, ascending order, past items removed
 */
const MONTH_NAMES_DE = {
  januar: 0,
  jan: 0,
  februar: 1,
  feb: 1,
  märz: 2,
  marz: 2,
  mär: 2,
  april: 3,
  apr: 3,
  mai: 4,
  juni: 5,
  jun: 5,
  juli: 6,
  jul: 6,
  august: 7,
  aug: 7,
  september: 8,
  sep: 8,
  sept: 8,
  oktober: 9,
  okt: 9,
  november: 10,
  nov: 10,
  dezember: 11,
  dez: 11,
};

const startOfToday = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};

const parseOne = (raw) => {
  if (!raw) return null;
  const cleaned = String(raw).trim();
  // dd.mm.yyyy
  let m = cleaned.match(/^(\d{1,2})\.(\d{1,2})\.(\d{2,4})$/);
  if (m) {
    let [, d, mm, y] = m;
    if (y.length === 2) y = `20${y}`;
    return new Date(parseInt(y, 10), parseInt(mm, 10) - 1, parseInt(d, 10));
  }
  // "12. Juli 2026"
  m = cleaned.match(/^(\d{1,2})\.\s*([A-Za-zäöüÄÖÜ]+)\s+(\d{4})$/);
  if (m) {
    const day = parseInt(m[1], 10);
    const mon = MONTH_NAMES_DE[m[2].toLowerCase()];
    if (mon !== undefined) return new Date(parseInt(m[3], 10), mon, day);
  }
  // ISO yyyy-mm-dd
  m = cleaned.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (m) return new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
  return null;
};

export const parseDateRange = (raw) => {
  if (!raw) return { start: null, end: null };
  const txt = String(raw);
  // Match a range "A - B" with various separators
  const sep = txt.split(/\s+[-–—bis]+\s+/i);
  if (sep.length === 2) {
    return { start: parseOne(sep[0]), end: parseOne(sep[1]) };
  }
  const single = parseOne(txt);
  return { start: single, end: single };
};

export const isUpcoming = (dateString) => {
  const { end, start } = parseDateRange(dateString);
  const ref = end || start;
  if (!ref) return true; // unparseable → don't hide
  return ref >= startOfToday();
};

export const byUpcomingDate = (a, b) => {
  const ad = parseDateRange(a && a.date).start;
  const bd = parseDateRange(b && b.date).start;
  if (ad && bd) return ad - bd;
  if (ad) return -1;
  if (bd) return 1;
  return 0;
};

export const filterUpcomingSorted = (items, dateField = 'date') => {
  if (!Array.isArray(items)) return [];
  const out = items.filter((it) => isUpcoming(it && it[dateField]));
  out.sort(byUpcomingDate);
  return out;
};
